"use strict";

angular.module("admin")
	.factory("ActionLogValueFormatter", [function () {

		const GEOJSON_TYPES = ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon",
			"GeometryCollection", "Feature", "FeatureCollection"];
		const GEOJSON_MAX_LENGTH = 160;
		// Au-delà, un objet / une liste imbriqué(e) est replié(e) par défaut
		const MAX_EXPANDED_ENTRIES = 10;
		const MAX_EXPANDED_DEPTH = 3;
		// Nombre d'éléments affichés avant le lien "Afficher les N autres"
		const ENTRIES_PAGE_SIZE = 50;
		// Une liste de valeurs simples plus courte que ça est affichée sur une ligne : "a, b, c"
		const INLINE_ARRAY_MAX_LENGTH = 100;
		// Ex : "Subscription:{...}" -> préfixe "Subscription" + JSON
		const PREFIXED_JSON_REGEX = /^([A-Za-z_$][\w$.-]*)\s*:\s*([[{][\s\S]*)$/;

		function isGeoJson(object) {
			return angular.isObject(object) && !angular.isArray(object) && GEOJSON_TYPES.indexOf(object.type) !== -1;
		}

		function truncate(text) {
			return text.length > GEOJSON_MAX_LENGTH ? text.substring(0, GEOJSON_MAX_LENGTH) + "..." : text;
		}

		function isEmpty(value) {
			return value === null || value === undefined
				|| (angular.isString(value) && (value.trim() === "" || value.trim() === "null"));
		}

		function primitiveNode(value) {
			if (isEmpty(value)) {
				return {kind: "primitive", text: "—", cssClass: "text-muted"};
			}
			if (value === true || value === false) {
				return {kind: "primitive", text: value ? "Oui" : "Non", cssClass: "action-log-boolean"};
			}
			if (angular.isNumber(value)) {
				return {kind: "primitive", text: String(value), cssClass: "action-log-number"};
			}
			return {kind: "primitive", text: String(value)};
		}

		function isPrimitive(value) {
			return value === null || !angular.isObject(value);
		}

		function arrayItemKey(item, index) {
			const key = "#" + (index + 1);
			if (angular.isObject(item) && !angular.isArray(item)) {
				const hint = item.name || item.label || item.code;
				if (hint && isPrimitive(hint)) {
					return key + " · " + hint;
				}
			}
			return key;
		}

		function buildNode(value, depth) {
			if (isPrimitive(value)) {
				return primitiveNode(value);
			}
			// Les coordonnées GeoJSON sont illisibles et très longues : on n'en affiche que le début
			if (isGeoJson(value)) {
				return {kind: "primitive", text: truncate(angular.toJson(value)), cssClass: "action-log-code"};
			}

			const isArray = angular.isArray(value);
			const keys = isArray ? value.map((item, index) => index) : Object.keys(value);
			if (!keys.length) {
				return {kind: "primitive", text: isArray ? "(liste vide)" : "(objet vide)", cssClass: "text-muted"};
			}
			if (isArray && value.every(isPrimitive)) {
				const inline = value.map((item) => primitiveNode(item).text).join(", ");
				if (inline.length <= INLINE_ARRAY_MAX_LENGTH) {
					return {kind: "primitive", text: inline};
				}
			}

			return {
				kind: isArray ? "array" : "object",
				summary: isArray
					? keys.length + " élément" + (keys.length > 1 ? "s" : "")
					: keys.length + " champ" + (keys.length > 1 ? "s" : ""),
				expanded: depth === 0 || (depth < MAX_EXPANDED_DEPTH && keys.length <= MAX_EXPANDED_ENTRIES),
				limit: ENTRIES_PAGE_SIZE,
				entries: keys.map((key) => ({
					key: isArray ? arrayItemKey(value[key], key) : key,
					node: buildNode(value[key], depth + 1)
				}))
			};
		}

		function parseJson(text) {
			try {
				return {ok: true, value: angular.fromJson(text)};
			} catch (e) {
				return {ok: false};
			}
		}

		function rawNode(text) {
			const looksLikeGeoJson = text.indexOf("\"coordinates\"") !== -1;
			return {kind: "raw", text: looksLikeGeoJson ? truncate(text) : text};
		}

		/**
		 * Transforme une valeur (objet, chaîne JSON, "Prefixe:{json}", texte...) en arbre affichable
		 * @returns {{prefix: string, node: Object}}
		 */
		function format(value) {
			if (!angular.isString(value)) {
				return {node: buildNode(value, 0)};
			}
			const text = value.trim();
			let prefix;
			let json = text;
			const prefixed = PREFIXED_JSON_REGEX.exec(text);
			if (prefixed) {
				prefix = prefixed[1];
				json = prefixed[2];
			}
			if (json.charAt(0) === "{" || json.charAt(0) === "[") {
				const parsed = parseJson(json);
				return {prefix: prefix, node: parsed.ok ? buildNode(parsed.value, 0) : rawNode(json)};
			}
			return {node: primitiveNode(value)};
		}

		return {
			format: format,
			isEmpty: isEmpty
		};
	}]);
